<template>
  <div class="login-container">
    <el-card class="login-card">
      <div slot="header">
        <span>登录</span>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="用户名">
            <i slot="prefix" class="el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="loginForm.password" placeholder="密码" @keyup.enter.native="handleLogin">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" style="width: 100%" :loading="loading" class="login-button">登录</el-button>
        </el-form-item>
        <div class="login-footer">
          <span>还没有账号？</span>
          <el-button type="text" @click="$router.push('/register')" class="register-link">立即注册</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { login } from '@/api'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false,
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            const res = await login(this.loginForm)
            if (res.status === 200) {
              localStorage.setItem('token', res.token)
              localStorage.setItem('username', this.loginForm.username)
              this.$message.success('登录成功')
              const redirect = typeof this.$route.query.redirect === 'string'
                ? this.$route.query.redirect
                : '/'
              this.$router.push(redirect)
            } else {
              this.$message.error(res.message || '登录失败')
            }
          } catch (error) {
            console.error('登录错误:', error)
            const message = error.response && error.response.data && error.response.data.message
            this.$message.error(message || '登录失败')
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - var(--header-height) - 6rem);
  padding: 1rem;
}
.login-card {
  width: min(100%, 400px);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.login-button {
  background-color: #409EFF;
  border-color: #409EFF;
  font-size: 16px;
  height: 40px;
  font-weight: 500;
}
.login-button:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}
.login-footer {
  text-align: center;
  margin-top: 20px;
  color: #606266;
}
.register-link {
  color: #409EFF;
  font-weight: 500;
  font-size: 14px;
}
.register-link:hover {
  color: #66b1ff;
}
</style>
